import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL;
const TranslatorRegisterPage = () => {
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', password: '' });
  const [motivation, setMotivation] = useState('');
  const [cvFile, setCvFile] = useState(null);
  const [agreed, setAgreed] = useState(false);
  
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => setFormData(p => ({ ...p, [e.target.name]: e.target.value }));
  const handleFileChange = (e) => setCvFile(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) { setError(t('must_agree_terms')); return; }
    if (!cvFile) { setError(t('cv_is_required')); return; }
    
    setError(''); setMessage(''); setIsLoading(true);
    const submissionData = new FormData();
    submissionData.append('firstName', formData.firstName);
    submissionData.append('lastName', formData.lastName);
    submissionData.append('email', formData.email);
    submissionData.append('password', formData.password);
    submissionData.append('motivation', motivation);
    submissionData.append('cvFile', cvFile);

    try {
      const response = await fetch(`${API_URL}/api/auth/register-translator`, {
        method: 'POST', body: submissionData,
      });
      const data = await response.json();
      if (!response.ok) { throw new Error(t(data.messageKey) || t('registration_failed')); }
      setMessage(t('translator_reg_success'));
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-form-card">
        <h2 className="auth-title">{t('translator_register_title')}</h2>
        <p className="auth-subtitle">{t('translator_register_prompt')}</p>
        
        {message ? (
          <div className="auth-success-message">
            <i className="fas fa-check-circle"></i>
            <h3>{t('application_received', 'Başvurunuz Alındı!')}</h3>
            <p>{t('translator_reg_success')}</p>
            <Link to="/" className="cta-button">{t('back_to_homepage', 'Anasayfaya Dön')}</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-row-auth">
              <div className="form-group-auth floating-label half-width"><input name="firstName" type="text" value={formData.firstName} onChange={handleChange} required placeholder=" " /><label>{t('first_name')}</label></div>
              <div className="form-group-auth floating-label half-width"><input name="lastName" type="text" value={formData.lastName} onChange={handleChange} required placeholder=" " /><label>{t('last_name')}</label></div>
            </div>
            <div className="form-group-auth floating-label"><input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder=" " /><label>{t('email_address')}</label></div>
            <div className="form-group-auth floating-label"><input name="password" type="password" value={formData.password} onChange={handleChange} required placeholder=" " /><label>{t('password')}</label></div>
            
            <div className="form-group-auth">
                <label className="static-label">{t('motivation_letter_optional')}</label>
                <textarea value={motivation} onChange={(e) => setMotivation(e.target.value)} rows="4" className="auth-textarea"></textarea>
            </div>
            
            <div className="form-group-auth">
                <label className="static-label">{t('cv_required')}</label>
                <label htmlFor="cv-upload" className="auth-file-input-label">
                    <i className="fas fa-paperclip"></i>
                    <span>{cvFile ? cvFile.name : t('select_file', 'Dosya Seç')}</span>
                </label>
                <input type="file" id="cv-upload" onChange={handleFileChange} accept=".pdf,.doc,.docx" required />
            </div>

            {error && <p className="auth-error">{error}</p>}
            
          <label className="auth-checkbox agreement">
  <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} /> 
  <span>
    <Trans i18nKey="agree_translator_terms_full">
     <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer" className="terms-link">Translator Agreement</Link>.
    </Trans>
  </span>
</label>
            <button type="submit" className="auth-submit-btn" disabled={isLoading || !agreed}>
              {isLoading ? t('sending_application') : t('submit_application')}
            </button>
            <p className="auth-redirect">{t('already_have_account')} <Link to="/login" className="auth-link">{t('login_button')}</Link></p>
          </form>
        )}
      </div>
    </div>
  );
};
export default TranslatorRegisterPage;